import type { EntitySpawn } from "../data/levels/types";

/**
 * Builds a stable identifier for each spawn from its kind and tile position, so
 * persisted state (defeated enemies, shell positions) survives reordering the
 * entity list. Duplicate kind/position pairs receive an ordinal suffix.
 */
export function buildSpawnIds(entities: readonly EntitySpawn[]): string[] {
  const seen = new Map<string, number>();
  return entities.map((entity) => {
    const base = spawnKey(entity);
    const count = seen.get(base) ?? 0;
    seen.set(base, count + 1);
    return count === 0 ? base : `${base}#${count}`;
  });
}

function spawnKey(entity: EntitySpawn): string {
  switch (entity.kind) {
    case "scale":
      return `scale:${entity.left}-${entity.right},${entity.ty}`;
    case "plant":
    case "podoboo":
      return `${entity.kind}:${entity.tx},g`;
    default:
      return `${entity.kind}:${entity.tx},${entity.ty}`;
  }
}
